import styled from 'styled-components'

export default styled.div`
  line-height: 16px;
  margin-left: 5.33vw;
  margin-bottom: 8px;
  width: 46.6vw;

  .product-name {
    margin-bottom: 5px;
  }

  .color-swatch {
    position: absolute;
    left: 1px;
    top: 2px;
  }

  .product-price {
    font-family: 'ABChanel PB Semibold L', Arial, sans-serif;
    font-weight: bold;
    margin-top: 12px;
    font-size: 11px;
  }

  .add-to-bag {
    margin-top: 12px;
    width: 120px;
    height: 42px;
    background-color: #000000;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 12px;
    color: #ffffff;
  }

  .product-state-label {
    margin-bottom: 10px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/ProductDetail.js